import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import UpdateWrapper from '../pages/updateprofile/UpdateWrapper'
import PropertyWrapper from '../pages/property/PropertyWrapper'
import TenantWrapper from '../pages/tenant/TenantWrapper'
import AgentWrapper from '../pages/agent/AgentWrapper'
import OwnerWrapper from '../pages/owner/OwnerWrapper'
import SuperAdminPropertyWrapper from '../pages/superAdmin/SAdminProperty/SuperAdminPropertyWrapper'
import SuperAdminUserWrapper from '../pages/superAdmin/SAdminUser/SuperAdminUserWrapper'
import SuperAdminSingleWrapper from '../pages/superAdmin/SAdminSingleProperty/SuperAdminSingleWrapper'
import PropertyViewWrapper from '../pages/property/View_Property/View_ProperyWrapper'
import PropertyUserWrapper from '../pages/propertyUsers/PropertyUserWrapper'
import EditPropertyWrapper from '../pages/propertyUsers/EditPropertyUser/EditPropertyUserWrapper'
import PropertyEditWrapper from '../pages/property/Edit_Propetry/Edit_PropertyWrapper'
import EnterpriseUserWrapper from '../pages/enterpriseAdmin/EnterpriseUser/EnterpriseUserWrapper'
import InvoiceWrapper from '../pages/invoices/InvoiceWrapper'
import ViewNewPropertyRoutes from '../pages/property/View_Property/ViewNewPropertyRoutes'
import ViewTenantRoutes from '../pages/tenant/ViewTenant/ViewTenantRoutes'
import SettingWrapper from '../pages/settings/SettingWrapper'
import SettingsRoute from '../pages/settings/SettingsRoutes'
import RentedPropertiesWrapper from '../pages/rentedProperties/RentedPropertiesWrapper'
import RentedPropertiesDetailPage from '../pages/rentedProperties/RentedPropertiesDetailPage'
import RentInfoRoutes from '../pages/property/RentInfo/RentInfoRoutes'
import KYCDetailWrapper from '../pages/KYCDetails/KYCDetailWrapper'
import ApproveKYCWrapper from '../pages/superAdmin/superAdminApproveKYC/ApproveKYCWrapper'
import ApproveKYCDetail from '../pages/superAdmin/superAdminApproveKYC/ApproveKYCDetail'
import TicketingWrapper from '../pages/ticketing/TicketingWrapper'
import TicketingDashboardWrapper from '../pages/ticketingDashboard/TicketingDashboardWrapper'
import AgreementWrapper from '../pages/agreement/AgreementWrapper'
import SuperAdminUserProperty from '../pages/superAdmin/SAdminUser/SuperAdminUserProperty'
import LeadManagementRoute from '../pages/leadManagement/LeadManagementRoutes'
import EstampRequestRoute from '../pages/superAdmin/superAdminEstampRequest/EstampRequestRoute'
import NotFoundComponent from '../pages/NotFoundComponent'
import RentPaymentSuccessPage from '../pages/rentedProperties/Components/RentPaymentSuccessPage'
import PaymentStatusPage from '../pages/PaymentStatusPage'
import AnalyticsWrapper from '../pages/analytics/AnalyticsWrapper'

// import Upload from
const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='tenentlist' element={<Navigate to='/tenant' />} />
        {/* Pages */}

        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* <Route path='builder' element={<BuilderPageWrapper />} /> */}
        {/* <Route path='menu-test' element={<MenuTestPage />} /> */}
        <Route path='update-profile' element={<UpdateWrapper />} />
        <Route path='user-settings/*' element={<SettingsRoute />} />
        <Route path='property' element={<PropertyWrapper />} />
        <Route path='KYC_Details' element={<KYCDetailWrapper />} />

        {/* property view routes */}
        <Route path='property/:id/*' element={<ViewNewPropertyRoutes />} />
        {/* property view routes */}
        <Route path='property/rent_info/:id/*' element={<RentInfoRoutes />} />

        {/* Tenant view routes */}
        <Route path='tenant/:id/*' element={<ViewTenantRoutes />} />

        {/* Tenant view routes */}
        <Route path='rented-properties/:id' element={<RentedPropertiesDetailPage />} />
        <Route path='rented-properties/:id/success' element={<RentPaymentSuccessPage />} />

        {/* <Route path='Newproperty' element={<PropertyNewNewHome />} /> */}
        <Route path='tenant/:id' element={<TenantWrapper />} />
        <Route path='tenant' element={<TenantWrapper />} />

        
        {/* <Route path='agent' element={<AgentWrapper />} /> */}
        {/* <Route path='owner' element={<OwnerWrapper />} /> */}
        <Route path='propertyUsers/:id' element={<PropertyUserWrapper />} />
        {/* <Route path='invoices' element={<InvoiceWrapper />} /> */}
        <Route path='tickets' element={<TicketingWrapper />} />
        {/* <Route path='ticket_dashboard' element={<TicketingDashboardWrapper />} /> */}
        <Route path='create_agreement' element={<AgreementWrapper />} />
        <Route path='lead_management/*' element={<LeadManagementRoute />} />
        <Route path='rented-properties' element={<RentedPropertiesWrapper />} />
        <Route path='payment/payment_status/:page' element={<PaymentStatusPage />} />

        <Route path='analytics' element={<AnalyticsWrapper />} />
        {/* property User */}
        {/* <Route path='editpropertyUsers' element={<EditPropertyWrapper />} /> */}

        {/* routes for super ADMIN */}
        <Route path='super_admin_property' element={<SuperAdminPropertyWrapper />} />
        <Route path='super_admin_user/property' element={<SuperAdminUserProperty />} />
        <Route path='super_admin_user/property/:id/*' element={<ViewNewPropertyRoutes />} />
        <Route path='super_admin_user' element={<SuperAdminUserWrapper />} />
        {/* <Route path='super_admin_single_user' element={<SuperAdminSingleWrapper />} /> */}
        <Route path='approve_kyc' element={<ApproveKYCWrapper />} />
        <Route path='approve_kyc/:id' element={<ApproveKYCDetail />} />
        <Route path='estamp_request/*' element={<EstampRequestRoute />} />
        {/* routes for Property View inside property */}

        {/* <Route path='property_View' element={<PropertyViewWrapper />} /> */}

        {/* routes for Property Edit inside property */}

        {/* <Route path='property_Edit' element={<PropertyEditWrapper />} /> */}

        {/* routes for enterprise admin */}

        {/* <Route path='enterprise_User_Home' element={<EnterpriseUserWrapper />} /> */}

        {/* Lazy Modules */}

        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='AddPropertyDocs'
          element={<Navigate to='../pages/property/Add_PropertyDocs' />}
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/404' />} />
        <Route path='/404' element={<NotFoundComponent />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
